const UA_EDGE = 'edge';
const UA_OPERA = 'opera';
const UA_CHROME = 'chrome';
const UA_IE = 'ie';
const UA_FIREFOX = 'firefox';
const UA_SAFARI = 'safari';
const UA_OTHER = 'other';

export default class UserAgent {
    _current;

    get code () {
        if (!this._current) {
            this._current = this._sniff();
        }

        return this._current;
    }

    get isEdge() {
        return this.is(UserAgent.EDGE);
    }

    get isOpera () {
        return this.is(UserAgent.OPERA);
    }

    get isChrome () {
        return this.is(UserAgent.CHROME);
    }

    get isIe () {
        return this.is(UserAgent.IE);
    }

    get isFirefox () {
        return this.is(UserAgent.FIREFOX);
    }

    get isSafari () {
        return this.is(UserAgent.SAFARI);
    }

    get isOther () {
        return this.is(UserAgent.OTHER);
    }

    is (code) {
        return code === this.code;
    }

    _sniff () {
        if (this._test(/edge/i)) {
            return UserAgent.EDGE;
        }
        if (this._test(/opr/i) && (!!window.opr || !!window.opera)) {
            return UserAgent.OPERA;
        }
        if (this._test(/chrome/i) && !!window.chrome) {
            return UserAgent.CHROME;
        }
        if (this._test(/trident/i)) {
            return UserAgent.IE;
        }
        if (this._test(/firefox/i)) {
            return UserAgent.FIREFOX;
        }
        if (this._test(/safari/i)) {
            return UserAgent.SAFARI;
        }

        return UserAgent.OTHER;
    }

    _test (pattern) {
        return pattern.test(window.navigator.userAgent);
    }

    static get EDGE () {
        return UA_EDGE;
    }

    static get OPERA () {
        return UA_OPERA;
    }

    static get CHROME () {
        return UA_CHROME;
    }

    static get IE () {
        return UA_IE;
    }

    static get FIREFOX () {
        return UA_FIREFOX;
    }

    static get SAFARI () {
        return UA_SAFARI;
    }

    static get OTHER () {
        return UA_OTHER;
    }
};